export const FSK_ID = 5747;

export const FSK_URL = 'https://www.cian.ru/zastroishchik-gk-fsk-5747/';
